import  * as component  from './components'

/*
const children = [{
  name: 'create.description',
  path: '/campaign/description/:id',
  component: component.description,
  meta: { requiresAuth: false },
}
]  */

export default [
    {
      name: 'report.campaigns',
      path: '/report/campaigns',
      component: component.Reporting,
      meta: { requiresAuth: true },
     },
     {
      name: 'report.repeatAffender',
      path: '/report/repeatAffender',
      component: component.RepeatAffender,
      meta: { requiresAuth: true },
     },
     {
      name: 'report.campaignreporting',
      path: '/report/campaigns/:id',
      component: component.campaignReporting,
      meta: { requiresAuth: true },
     },
     {
      name: 'report.recipientlisting',
      path: '/report/campaigns/:id/:type?name',
      component: component.recipientListing,
      meta: { requiresAuth: true },
     },
    /* {
      name: 'report.recipientprofile',
      path: '/report/recepients/:tid',
      component: component.recipientProfile,
      meta: { requiresAuth: true },
     }, */
   /* {
      children,
      name: 'create.index',
      path: '/create',
      component: component.createCampaignMain,
      redirect: { name: 'create.scenario' },
      meta: { requiresAuth: false },
    } */
]



// WEBPACK FOOTER //
// ./src/app/report/routes/index.js